import { HxAccount, HxCollection, HxSyncDeviceAccountType } from '@outlook/hxcore_web';
import { AccountType, getProfileStore } from 'owa-mail-account-store';

export function setProfileStoreAccounts(hxAccounts: HxCollection<HxAccount>) {
    getProfileStore().accounts = hxAccounts.items.map(hxAccount => ({
        accountId: hxAccount.stableAccountId,
        accountType: getAccountTypeByHxSyncDeviceAccountType(
            hxAccount.syncSettings_SyncDeviceAccountTypeId
        ),
        emailAddress: hxAccount.emailAddress,
        displayName: hxAccount.userDisplayName,
    }));
}

function getAccountTypeByHxSyncDeviceAccountType(
    accountType: HxSyncDeviceAccountType
): AccountType {
    switch (accountType) {
        case HxSyncDeviceAccountType.ActiveSyncExchange:
            return AccountType.Office365;
        case HxSyncDeviceAccountType.ActiveSyncMicrosoft:
            return AccountType.OutlookDotCom;
        case HxSyncDeviceAccountType.ActiveSyncGoogle:
        case HxSyncDeviceAccountType.InternetGoogle:
            return AccountType.Google;
        case HxSyncDeviceAccountType.InternetYahoo:
            return AccountType.Yahoo;
        case HxSyncDeviceAccountType.InternetICloud:
            return AccountType.iCloud;
        default:
            return AccountType.Unknown;
    }
}
